import { Grid } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const SkipToContentWrapper = styled.div`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;

    background: ${getPurpurColor('backgroundSecondary')};
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};

    &:has(a:focus-visible) {
        position: static;
        width: auto;
        height: auto;
    }
`;

export const SkipToContentContainer = styled(Grid)`
    padding: ${getPurpurSpacing('100')} 0;
`;
